<template>
  <div class="box">
    <div class="box2">
      <div class="box-content">
        <div class="statistics">
          <div class="statistics-item" v-for="item in statisticsList" :key="item">
            <div class="statistics-item-left">
              <span class="iconfont icon-guanwang icon"></span>
              <span class="label">{{ item.name }}</span>
            </div>
            <div class="statistics-item-right">{{ item.data }}</div>
          </div>
        </div>
        <div class="analysis">
          <div class="analysis-title">
            <div class="title">压力-流量波动分析</div>
            <div class="select">
              <el-select style="width:80%;" size="mini" v-model="form.fluctuationAnalysis" clearable placeholder="请选择">
                <el-option
                  v-for="item in fluctuationAnalysiss"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div id="analysis-chart"></div>
        </div>
        <div class="online-statistics">
          <div class="title">监测点在线统计</div>
          <div id="online-statistics-chart"></div>
        </div>
        <div class="alarm-statistics">
          <div class="title">报警统计</div>
          <div class="alarm-statistics-content">
            <div class="alarm-item" v-for="item in 10" :key="item">
              <span class="iconfont icon-guanwang icon"></span>
              <span class="alarm-text">东环路1号管网于2024-03-20 09:11:18，压力超出上限预警值，数据为0.65Mpa</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import dayjs from "dayjs"
export default {
  data() {
    return {
      statisticsList: [
        { name: '监测点总数', data: 12},
        { name: '在线总数', data: 12},
        { name: '离线总数', data: 0},
        { name: '压力异常总数', data: 1},
      ],
      form: {
        fluctuationAnalysis: 1
      },
      fluctuationAnalysiss: [
        {id: 1,name: '东道1号管网'}
      ]
    };
  },
  methods: {
    setAnalysisChart() {
      var myChart = echarts.init(document.getElementById('analysis-chart'));
      var option = {
        title: {
          subtext: '单位: m³/h'
        },
        backgroundColor: '',
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          y: 'top',
          data: ['压力', '流量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '压力',
            type: 'line',
            stack: 'Total',
            areaStyle: {
              opacity: 0.1
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#5CCCFC',
              shadowColor: '#5CCCFC',
            },
            lineStyle: {
              shadowColor: '#5CCCFC',
              shadowBlur: 20,
              color: {
                type: 'linear',
                colorStops: [
                  {offset:0,color:'#5CCCFC'},
                  {offset:1,color:'#5CCCFC'},
                ]
              }
            },
            smooth: true,
            data: [19,50,30,40,70,30]
          },
          {
            name: '流量',
            type: 'line',
            stack: 'Total',
            areaStyle: {
              opacity: 0.1
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: '#9690FA',
              shadowColor: '#9690FA',
            },
            lineStyle: {
              shadowColor: '#9690FA',
              shadowBlur: 20,
              color: {
                type: 'linear',
                colorStops: [
                  {offset:0,color:'#9690FA'},
                  {offset:1,color:'#9690FA'},
                ]
              }
            },
            smooth: true,
            data: [19,81,24,26,52,47]
          }
        ],
      };
      myChart.setOption(option);
    },
    setOnlineStatisticsChart() {
      var myChart = echarts.init(document.getElementById('online-statistics-chart'));
      var option = {
        title: {
          subtext: ''
        },
        backgroundColor: '',
        tooltip: {
          trigger: "item"
        },
        legend: {
          y: 'top',
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            name: '在线统计',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 0,
              borderColor: '#fff',
              borderWidth: 2,
              color: function(params) {
                var colorList = ['#2FADFB']
                return colorList[params.dataIndex]
              }
            },
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#4c4a4a',
                formatter: '{total|' + '100%' +'}'+'\n\r'+'{active|测站在线率}',
                rich: {
                  total: {
                    fontSize: 20,
                    fontFamily: 'Microsoft YaHei',
                    color: '#2FADFB',
                    fontWeight: 'bold'
                  },
                  active: {
                    fontSize: 12,
                    fontFamily: 'Microsoft YaHei',
                    color: '#6c7a89',
                    lineHeight: 20
                  }
                }
              },
              emphasis: {
                show: true,
              }
            },
            emphasis: {
              itemStyle: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold',
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 100, name: '数据' },
            ]
          }
        ],
      };
      myChart.setOption(option);
    }
  },
  mounted() {
    this.setAnalysisChart()
    this.setOnlineStatisticsChart()
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 480px;
}
.box-title {
  color: #202020;
  font-size: 18px;
  padding: 0 16px;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
}
.box {
  border-bottom: 14px solid #FAFAFA;
  background: #FAFAFA;
  .box2 {
    border-radius: 10px;
    background: #FFF;
  }
  .content {
    padding: 0 16px;
    padding-bottom: 16px;
  }
}
.box-content {
  display: flex;
  padding: 20px;
  font-size: 14px;
  .title { 
    color: #202020;
    font-size: 17px;
    padding: 0 16px;
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    position: relative;
  }
  .statistics {
    width: 15%;
    margin-right: 30px;
    .statistics-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      .statistics-item-left {
        display: flex;
        align-items: center;
        .icon {
          border: 2px solid #009CFB;
          color: #009CFB;
          border-radius: 50%;
          padding: 5px;
          font-size: 20px;
          margin-right: 10px;
        }
      }
      .statistics-item-right {
        font-size: 16px;
        font-weight: bold;
        color: #009CFB;
      }
    }
  }
  .analysis {
    width: 35%;
    margin-right: 30px;
    .analysis-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select {
        color: #009CFB;
        text-align: right;
      }
    }
    #analysis-chart {
      height: 200px;
    }
  }
  .online-statistics {
    width: 15%;
    margin-right: 30px;
    #online-statistics-chart {
      height: 200px;
    }
  }
  .alarm-statistics {
    width: 35%;
    .alarm-statistics-content {
      padding: 0 20px;
      height: 200px;
      overflow-y: scroll;
      .alarm-item {
        display: flex;
        align-items: center;
        border: 1px solid #FFDFD8;
        border-radius: 4px;
        padding: 5px 10px;
        margin: 5px 0;
        background-color: #FFF6F6;
        .icon {
          font-size: 20px;
          color: #FF9048;
          margin-right: 10px;
          margin-top: 3px;
        }
      }
    }
  }
}
</style>